import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminServices = {
  approveCashIN,
  rejectCashIn,
  getCashIn,
  getCashInDownload,
  getCashOut,
  getCashOutDownload,
  getAccounts,
  getAccountHistories,
  updateCashout,
  approveCashOUT,
  getAccountMonitoring,
  trfdanaantaskas,
  getSumCashin,
  getSumCashOut
}

function getSumCashin (opt) {
  return fetch(API_URL + '/api/admin/v1/payment/sumcashin?awal=' + opt.awal + '&akhir=' + opt.akhir, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSumCashOut (opt) {
  return fetch(API_URL + '/api/admin/v1/payment/sumcashout?awal=' + opt.awal + '&akhir=' + opt.akhir, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getAccountMonitoring () {
  return fetch(API_URL + '/api/admin/v1/accounts/monitoring', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getAccounts () {
  return fetch(API_URL + '/api/admin/v1/accounts', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getAccountHistories (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('acchissort')
    } else {
      localStorage.setItem('acchissort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/account/histories?search=' + opt.search + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getCashInDownload (opt) {
  return fetch(API_URL + '/api/admin/v1/payment/histories/0/export?&awal=' + opt.awal + '&akhir=' + opt.akhir, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getCashOutDownload (opt) {
  return fetch(API_URL + '/api/admin/v1/payment/histories/1/export?&awal=' + opt.awal + '&akhir=' + opt.akhir, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getCashOut (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('cashoutsort')
    } else {
      localStorage.setItem('cashoutsort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }

  if (typeof opt.methode === 'undefined' || opt.methode === null) {
    opt.methode = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/payment/histories/1?search=' + opt.search + '&method=' + opt.methode + '&status=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getCashIn (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('cashinsort')
    } else {
      localStorage.setItem('cashinsort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (!opt.statustrx) {
    opt.statustrx = ''
  }

  if (!opt.statustrx) {
    opt.statustrx = ''
  }
  if (!opt.methode) {
    opt.methode = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/payment/histories/0?search=' + opt.search + '&method=' + opt.methode + '&status=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function rejectCashIn (postdata) {
  return fetch(API_URL + '/api/admin/v1/payment/tiket/update/' + postdata.id + '/' + postdata.status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function approveCashIN (postdata) {
  return fetch(API_URL + '/api/admin/v1/payment/tiket/approve', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function trfdanaantaskas (postdata) {
  return fetch(API_URL + '/api/admin/v1/accounts/transfer', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function approveCashOUT (postdata) {
  return fetch(API_URL + '/api/admin/v1/payment/tiket/approve', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateCashout (postdata) {
  return fetch(API_URL + '/api/admin/v1/payment/tiket/update/' + postdata.id + '/' + postdata.status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
